/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import type { Params } from 'react-router-dom';

import {
  isEndpointUpdatePendingCancelable,
  isEndpointUpdateable,
} from '@fai/friendli-suite/features/products/dedicated-endpoints/endpoints/endpoint-status';
import { checkEndpointUpdatePending } from '@fai/friendli-suite/features/routes/loaders/apis/product/dedicated-endpoints/check-endpoint-update-pending';
import { getEndpointStatus } from '@fai/friendli-suite/features/routes/loaders/apis/product/dedicated-endpoints/get-endpoint-status';
import { customJson } from '@fai/third-party/react-router-dom';

export const checkIsEndpointUpdatable = async ({ params }: { params: Params<'endpointId'> }) => {
  const endpointId = params.endpointId ?? '';
  const status = await getEndpointStatus({ endpointId });
  const isUpdatePending = await checkEndpointUpdatePending({ endpointId });

  if (
    !isEndpointUpdateable(status) ||
    (isEndpointUpdatePendingCancelable(status) && isUpdatePending)
  ) {
    throw customJson({ message: 'This page is inaccessible.' }, { status: 403 });
  }

  return null;
};
